// extracted by mini-css-extract-plugin
export default {"get_it_now_v2":"jl","place_order_copy":"kl","next_order_copy":"ll","title_wrapper":"ml","get_it_now_row":"nl","get_it_now_remaining_items":"ol","get_it_now_remaining_items_mob":"pl","order_summary":"ql","additional_items":"rl","account_content_slider":"sl","ingredient_carousel":"tl","ingredient_carouselwrapper":"ul","account_content_slide":"vl","account_subscription_section_mob":"wl","carouselwrapper":"xl"};
    if(module.hot) {
      // 1737143651181
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  